var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonPrism16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 8.5c3.59 0 6.5 2.374 6.5 5.303 0 2.93-13 2.93-13 0C1.5 10.874 4.41 8.5 8 8.5zM8 0a3.5 3.5 0 110 7 3.5 3.5 0 010-7z",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8.5c3.59 0 6.5 2.374 6.5 5.303 0 2.93-13 2.93-13 0 0-2.862 2.78-5.195 6.256-5.3L8 8.5zM8 10c-2.66 0-4.749 1.58-4.979 3.459l-.013.141.055.038c.16.103.401.212.708.315l.192.061c1.03.31 2.497.486 4.037.486s3.007-.176 4.037-.486c.4-.12.707-.252.9-.376l.054-.038-.012-.141c-.223-1.822-2.194-3.363-4.739-3.455L8 10zM8 0a3.5 3.5 0 01.192 6.995L8 7A3.5 3.5 0 017.808.005L8 0zm0 1.5a2 2 0 100 4 2 2 0 000-4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonPrism16);
export default __webpack_public_path__ + "static/media/person-prism-16.6c5d5a1e.svg";
export { ForwardRef as ReactComponent };